import React, { useState } from 'react';
import './product_audit.css';
import { faFeather, faFileInvoice, faSync, faKeyboard, faChartBar, faBarcode, faFileAlt, faShapes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Trial from '../Trial';

export default function Whatsnew() {
    const [activeIndex, setActiveIndex] = useState(null);
    const [activeIndexd, setActiveIndexd] = useState(null);

    const dtoggleAccordion = (index) => {
        setActiveIndexd(activeIndexd === index ? null : index);
    };
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    const Reportdesign = [
        {
            title: "Drag-and-Drop Interface",
            content:
                "Intuitive drag-and-drop interface for effortless report design, making it easy for users to arrange and organize elements on the report canvas.",
        },
        {
            title: "Data Source Integration",
            content:
                "Connect seamlessly to various data sources, including databases and spreadsheets, to pull in and analyze real-time data for comprehensive reporting.",
        },
        {
            title: "Parameterized Reports",
            content:
                "Create dynamic reports with parameters, allowing users to customize data filters and criteria to meet their specific reporting needs.",
        },
        {
            title: "Formatting Options",
            content:
                "Full control over fonts, colors, and styles to ensure that your reports align with your organization's branding and visual preferences.",
        },
        {
            title: "Chart and Graph Integration",
            content:
                "Incorporate a variety of charts and graphs to visually represent data trends and insights, providing a clear overview of key metrics.",
        },
        {
            title: "Export and Sharing",
            content:
                "Effortlessly export reports in multiple formats (PDF, Excel, CSV) and share them with stakeholders, facilitating easy collaboration and communication.",
        },
        {
            title: "Conditional Formatting",
            content:
                "Apply formatting rules based on specified conditions to enhance the visual representation of data and highlight important information.",
        },
        {
            title: "Calculation and Formula Support",
            content:
                "Include calculated fields and formulas within the report for performing computations on the data, enabling advanced analysis and insights.",
        },
        {
            title: "Grouping and Sorting",
            content:
                "Organize data effectively with options for grouping and sorting, ensuring a logical and structured presentation of information.",
        },
        {
            title: "Templates",
            content:
                "Save and reuse report templates for consistency across different reports, streamlining the report creation process.",
        },
    ];
    const Dashboardesign = [
        {
            title: "Customizable Solutions",
            content:
                "Tailor Auditus-IERP to fit your startup's unique needs with solutions that adapt to your business requirements.",
        },
        {
            title: "Scalability",
            content:
                "As your startup grows, Auditus-IERP scales with you to remain a reliable and efficient solution.",
        },
        {
            title: "Collaborative Tools",
            content:
                "Enhance teamwork with secure financial data sharing and streamlined communication features.",
        },
        {
            title: "Customizable Dashboards",
            content:
                "Design personalized dashboards to monitor key metrics and insights important to your startup.",
        },
        {
            title: "Drag-and-Drop Widget Placement",
            content:
                "Easily arrange widgets on dashboards using an intuitive drag-and-drop interface.",
        },
        {
            title: "Real-time Data Integration",
            content:
                "Seamlessly integrate real-time data from multiple sources for up-to-date decision-making insights.",
        },
        {
            title: "Data Visualization Widgets",
            content:
                "Use charts, graphs, and gauges to transform complex data into easily understandable visuals.",
        },
        {
            title: "Performance Metrics Monitoring",
            content:
                "Track critical KPIs and metrics to evaluate and improve your startup’s performance.",
        },
        {
            title: "Interactive Drill-Down Functionality",
            content:
                "Explore specific data points in detail directly from the dashboard for deeper analysis.",
        },
        {
            title: "Customizable Time Periods",
            content:
                "Adjust dashboards to show historical or real-time data over selectable time ranges.",
        }
    ];
    const features = [
        {
            icon: 'fas fa-sliders-h',
            title: 'Feature Master for Dynamic Voucher Entry',
            description: 'Custom fields in vouchers adapt automatically based on whether the transaction is for accounts, inventory, or services—streamlining data entry and accuracy.'
        },
        {
            icon: 'fas fa-file-invoice',
            title: 'Unified Invoice for Goods & Services',
            description: 'Create a single invoice that seamlessly includes both goods and service items, simplifying billing and reducing errors.'
        },
        {
            icon: 'fas fa-sync-alt',
            title: 'Live Row-by-Row Data Sync',
            description: 'Real-time updates during voucher entry ensure immediate reflection of stock levels and account balances, even in multi-user environments.'
        },
        {
            icon: 'fas fa-keyboard',
            title: 'Ctrl+Q Smart Query Window',
            description: 'Access all search and query operations using just one shortcut key—Ctrl+Q—eliminating the need to remember multiple key combinations.'
        },
        {
            icon: 'fas fa-chart-line',
            title: 'Drill-Down Reporting from Vouchers',
            description: 'Easily drill down from summary reports to specific voucher entries, enabling faster audit and verification.'
        },
        {
            icon: 'fas fa-barcode',
            title: 'Barcode Read & Custom Design',
            description: 'Supports EAN barcode scanning and lets users design their own barcode layouts for both reading and printing.'
        },
        {
            icon: 'fas fa-file-signature',
            title: 'Customizable Invoice Design',
            description: 'Design and format invoices to match branding and business needs with flexible layout tools.'
        },
        {
            icon: 'fas fa-file-alt',
            title: 'Tailored Report Format Designer',
            description: 'Create business-specific reports with fully customizable templates for printing, exporting, or analysis.'
        },
        // Additional Features
        {
            icon: 'fas fa-globe',
            title: 'Multi-Currency Support',
            description: 'Handle transactions in multiple currencies, with automatic exchange rate updates, ensuring global business operations are smooth and accurate.'
        },
        {
            icon: 'fas fa-user-shield',
            title: 'Role-Based Access Control',
            description: 'Assign user permissions based on roles within the organization, ensuring data security and restricted access to sensitive information.'
        },
        {
            icon: 'fas fa-calculator',
            title: 'Automatic Tax Calculation',
            description: 'Automatically calculate taxes based on user-defined tax rates, jurisdictions, and product categories, minimizing the risk of errors.'
        },
        {
            icon: 'fas fa-clipboard-list',
            title: 'Sales Order and Purchase Order Management',
            description: 'Create and manage sales and purchase orders with integrated stock and financial tracking, improving order accuracy and efficiency.'
        },
        {
            icon: 'fas fa-university',
            title: 'Integration with Banking Systems',
            description: 'Seamlessly integrate with banking systems to facilitate real-time reconciliation of bank statements and payments.'
        },
        {
            icon: 'fas fa-tachometer-alt',
            title: 'Customizable Dashboards',
            description: 'Personalize dashboards for each user to display key metrics, financial data, and reports, providing real-time insights and better decision-making.'
        },
        {
            icon: 'fas fa-file-contract',
            title: 'Audit Trail for Data Integrity',
            description: 'Keep a complete, unalterable record of all system changes, ensuring compliance and providing a reliable audit trail for legal and operational purposes.'
        },
        {
            icon: 'fas fa-cloud',
            title: 'Cloud and On-Premises Deployment',
            description: 'Offer flexibility with both cloud-based and on-premises deployment options, giving businesses control over their software environment and data security.'
        }
    ];

    return (
        <div className="product-overview-container">
            <div className="hero-content">
                <div className="text-section">
                    <h1>Experience the Future of ERP with the All-New Auditusierp</h1>
                    <p>
                        Discover a faster, smarter, and more intuitive way to manage your business — with powerful features,
                        improved performance, and a refreshed user experience designed to help you work better every day.
                    </p>
                </div>
                <div className="image-section">
                    <img src='../../../../images/whatnew.jpg' alt="Auditusierp Overview" />
                </div>
            </div>

            <div className="new_section">
                <div className="feature-intro">
                    <h2>What’s New in Auditusierp</h2>
                </div>
                <div className="features-grid">
                    {features.map((feature, index) => {
                        const iconColors = [
                            '#e74c3c', '#2ecc71', '#f39c12', '#9b59b6',
                            '#16a085', '#d35400', '#3498db', '#e67e22',
                            '#1abc9c', '#8e44ad', '#c0392b', '#2980b9',
                            '#27ae60', '#f1c40f', '#34495e', '#fd79a8'
                        ];
                        return (
                            <div key={index} className={`feature-box feature-color-${index % 6}`}>
                                <i className={`feature-icon-new ${feature.icon}`} style={{ color: iconColors[index % iconColors.length] }}></i>
                                <h3 className="feature-title">{feature.title}</h3>
                                <p className="feature-description">{feature.description}</p>
                            </div>
                        );
                    })}
                </div>

                {/* Side-by-side container */}
                <div className="new_boxes_wrapper">

                    {/* Report Designer Box */}
                    <div className='new_container'>
                        <h2 className='new_tit'>Report Designer</h2>
                        <p className='new_par'>Revolutionize your reporting experience with Auditus-IERP's advanced Report Designer Tool. Unleash creativity and precision as you effortlessly design dynamic reports using a comprehensive suite of intuitive tools, ensuring your data speaks volumes in a visually compelling manner</p>
                        <div className="accordion-section">
                            {Reportdesign.map((item, index) => (
                                <div key={index} className="accordion-item">
                                    <div className={`accordion-title ${activeIndex === index ? 'active' : ''}`} onClick={() => toggleAccordion(index)}>
                                        {item.title}
                                        <span>{activeIndex === index ? '-' : '+'}</span>
                                    </div>
                                    {activeIndex === index && <div className="accordion-content">{item.content}</div>}
                                </div>
                            ))}
                        </div>
                    </div>

                    {/* Dashboard Designer Box */}
                    <div className='new_container'>
                        <h2 className='new_tit'>Dashboard Designer</h2>
                        <p className='new_par'>Empower decision-making with Auditus-IERP's Dashboard Designer, featuring a dynamic interface for at-a-glance insights. Monitor profits, losses, and more through customizable tools, ensuring a comprehensive view of your business performance</p>
                        <div className="accordion-section">
                            {Dashboardesign.map((item, index) => (
                                <div key={index} className="accordion-item">
                                    <div className={`accordion-title ${activeIndexd === index ? 'active' : ''}`} onClick={() => dtoggleAccordion(index)}>
                                        {item.title}
                                        <span>{activeIndexd === index ? '-' : '+'}</span>
                                    </div>
                                    {activeIndexd === index && <div className="accordion-content">{item.content}</div>}
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </div>

            <Trial/>
        </div>
    );
}
